<template>
  <AppLayout>
    <template #middle>
      <InnerContent>
        <SessionsContent />
      </InnerContent>
    </template>
  </AppLayout>
</template>

<script setup lang="ts">
import AppLayout from '@/(routes)/(protected)/(app)/layout.vue'
import InnerContent from '@/features/ui/components/inner-content/inner-content.vue'
import SessionsContent from '@/features/ui/pages/admin/sessions/sessions-content/sessions-content.vue'
</script>
